import React from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import LockIcon from "./LockIcon";

import "./Navigation.css";

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = () => ({});

// Convert to function component to use hooks
function Navigation() {
  const location = useLocation();
  const path = location.pathname;
  const etusivuClass = path.length === 1 ? "active" : null;

  return (
    <nav>
      <ul>
        <li className={etusivuClass}>
          <Link to="/">Etusivu</Link>
        </li>
        <li className={path.startsWith("/taustaa") ? "active" : null}>
          <Link to="/taustaa/">Taustaa</Link>
        </li>
        <li className={path.startsWith("/yhteydenotto") ? "active" : null}>
          <Link to="/yhteydenotto/">Ota yhteyttä</Link>
        </li>
        <LockIcon />
      </ul>
    </nav>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
